// HomePage
import Blank from "./Screens/Blank.js";
import Home from "./Screens/Home/Main.js";

// Admin
import PartnerAdmin from "./Screens/Admin/Main.js";
import UserAdmin from "./Screens/Admin/Main.js";

// Partner related
import PartnerHome from "./Screens/Partner/Main.js";
import PartnerRegistration from "./Screens/Partner/Register.js";
import QuemSomos from "./Screens/QuemSomos/Main.js";
import Blog from "./Screens/Blog/Main.js";
import BlogView from "./Screens/Blog/View.js";
import TermsView from "./Screens/Terms/Main.js";


var dashRoutes = [
  {
    path: "/",
    name: "Início",
    component: Home
  },  
  {
    path: "/parceiros",
    name: "Parceiros",
    component: PartnerHome
  },
  {
    path: "/parceiros/cadastro",
    name: "Cadastro de Parceiro",
    component: PartnerRegistration
  },
  {
    path: "/quem-somos",
    name: "Quem somos",
    component: QuemSomos
  },
  {
    path: "/noticias",
    name: "Notícias",
    component: Blog
  },  
  {
    path: "/noticias/:slugId",
    name: "Notícia",
    component: BlogView
  },
  {
    path: "/termos",
    name: "Termos de uso, Política de Privacidade e Preferências de Cookies",
    component: TermsView
  },   
  {
    path: "/termos/:tab",
    name: "Termos de uso, Política de Privacidade e Preferências de Cookies",
    component: TermsView
  },          
  { 
    path: "/parceiros/painel",
    name: "Área administrativa",
    component: PartnerAdmin
  },          
  { 
    path: "/painel",
    name: "Área administrativa",
    component: UserAdmin
  }     
];
export default dashRoutes;
